<template>
  <div class="flex justify-center">
    <div
      class="max-w-full grow px-16 md:px-24 lg:max-w-[1184px] lg:basis-full lg:px-32"
    >
      <slot />
    </div>
  </div>
</template>
